module.exports = __webpack_public_path__ + "static/media/player-avatar-7.ead955b5.png";